<template>
  <div class="container-fluid">
    <page-header :page="page" />
    <menu-options :menu-title="navTitle" />
  </div>
</template>

<script>
import MenuOptions from '@/components/common/menu/MenuOptions';
import navMenuTitles from '@/utils/constants/navMenuTitles';
import PageHeader from 'PageHeader';

export default {
  components: {
    MenuOptions,
    PageHeader,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-cog',
        title: 'Usuario',
        routes: ['Inicio', 'Usuario'],
      },
      navTitle: navMenuTitles.User,
    };
  },
};
</script>
